import { useEffect } from 'react';

import useFilesInDocumentStore from '@/components/controls/DropScan/useFilesInDocument.store';
import { LMN_UPLOAD_STORE_KEY } from '@/modules/MyDocuments/myDocuments.types';
import { useStore } from '@/modules/transaction/components/ReimburseMe/store/usePaymentMethods.store';
import { useDocumentOcrStore, useMyMoneyFormStore, useMyMoneyStore } from '@/modules/UseMyMoney/stores';
import { USE_MY_MONEY_UPLOAD_STORE_KEY } from '@/modules/UseMyMoney/UseMyMoney.types';

export const useResetUseMyMoney = () => {
  const { resetStore } = useMyMoneyStore();
  const { resetDocumentOcrState } = useDocumentOcrStore();
  const { handleResetFormStore } = useMyMoneyFormStore();
  const handleClear = useStore((state) => state.handleClear);
  const { handleReset } = useFilesInDocumentStore(USE_MY_MONEY_UPLOAD_STORE_KEY);
  const { handleReset: handleResetLmnDocumentStore } = useFilesInDocumentStore(LMN_UPLOAD_STORE_KEY);

  useEffect(() => {
    return () => {
      resetStore();
      resetDocumentOcrState();
      handleReset();
      handleResetFormStore();
      handleResetLmnDocumentStore();
      handleClear();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
